module.exports = __webpack_public_path__ + "img/bear5.d18ff3c7.png";